let widget = document.querySelector('custom-recharge-widget')
let formular = document.querySelector("product-form")
let hidden_selling_plan_inputs = document.querySelectorAll('input[name="selling_plan"]')
let currency = widget.dataset.currencyDefault.replace("1","").replace("00","").replace(".","").replace(",","")
let index_of_1 = widget.dataset.currencyDefault.indexOf("1")
let currency_pos_after = false
if(index_of_1 == 0){
  currency_pos_after = true
}

function setVariants(){
  document.querySelectorAll(".variant-picker__option input:checked").forEach(selectedVariant=>{
   let selectedValue =  selectedVariant.dataset.inputValue
   let selectedName =  selectedVariant.name
   console.log("dropdown",document.querySelectorAll(`#dropdown-${selectedName} option`),selectedName,selectedValue)
    document.querySelectorAll(`#dropdown-${selectedName} option`).forEach(dropdownOption => {
      if(dropdownOption.dataset.inputValue == selectedValue){
        dropdownOption.selected=true
      }
    })

  })
}

document.querySelectorAll("quantity-selector--mobile").forEach(select => {
  select.addEventListener("change", (event)=>{
    updateAllQuantityInputs(event.target.value)
  })
})

document.querySelectorAll(".variant-picker__option").forEach(ele=>{
  ele.addEventListener("click",()=>{
    setVariants()
  })
})

function updatePrice(newQuantity) {
  console.log("ipdate")
      let new_discout_price = (Number(widget.dataset.discountPrice.replace(",", ".")) * newQuantity).toFixed(2)
    let new_price = (Number(widget.dataset.originalPrice.replace(",", ".")) * newQuantity).toFixed(2)
   
    if(currency_pos_after){
      widget.querySelector(".discount-price").innerHTML =  new_discout_price + currency;
      widget.querySelectorAll(".original-price").forEach(price => { price.innerHTML = new_price + currency})
    }
    else {
      widget.querySelector(".discount-price").innerHTML = currency + new_discout_price;
      widget.querySelectorAll(".original-price").forEach(price => { price.innerHTML = currency + new_price })
    }
}

function updateAllQuantityInputs(newQuantity) {
  console.log("test")
  document.querySelectorAll("quantity-selector--mobile select").forEach(ele => ele.value = newQuantity)
  document.querySelectorAll(".quantity-input__element").forEach(ele => ele.value = newQuantity)
  document.querySelectorAll("input[name='quantity']").forEach(ele => ele.value = newQuantity)
  updatePrice(newQuantity)
}

function setAutomaticSelectorOnLoad(){


  
  let checkedVariants = document.querySelectorAll("[data-select-subscription-plan] input:checked")
  checkedVariants.forEach(ele=> 
   { 
    let planValue = ele.closest("[data-select-subscription-plan]")?.dataset?.selectSubscriptionPlan?.toLowerCase().trim()
    let quantityValue = Number(ele.closest("[data-selected-quantity]")?.dataset?.selectedQuantity) 
     updateAllQuantityInputs(quantityValue)
    
     document.querySelectorAll("[data-plan-name]").forEach(selectOption => {
      if (selectOption.dataset.planName.toLowerCase().trim().includes(planValue)) {
     
    selectOption.selected = true 
        setSellingPlan(selectOption.value, true) 
      }
    })}
    
    )
}

function setAutomaticSelector(){
  document.querySelectorAll("[data-select-subscription-plan]")
  .forEach(
    variantOption => {
      variantOption.addEventListener("click",(event)=>{
        let target = event.target.closest("[data-select-subscription-plan]")
        let planValue = target.dataset.selectSubscriptionPlan.toLowerCase().trim()
        let quantityValue = Number(target.closest("[data-selected-quantity]")?.dataset?.selectedQuantity) 
       updateAllQuantityInputs(quantityValue)
    
        
        document.querySelectorAll("[data-plan-name]").forEach(selectOption => {
          if (selectOption.dataset.planName.toLowerCase().trim().includes(planValue)) {
            selectOption.selected=true
            setSellingPlan(selectOption.value, false) 
          }
        })
      })
    }
  )
  
}

function setDefault(){
  document.querySelector(".selling_plan-input.selling_plan.radio-furlife-container.active").click()
}

function setSellingPlan(selling_plan, open_tab) {


// deactivate other checkbox
document.querySelectorAll(".selling_plan-input .active").forEach(ele => ele.classList.remove("active"))
 
  let selling_plan_tab = widget.querySelector(".selling_plan-tab")
  let no_selling_plan_tab = widget.querySelector(".no_selling_plan-tab")
  let selling_plan_input = widget.querySelector(".selling_plan-input.selling_plan")
  let no_selling_plan_input = widget.querySelector(".selling_plan-input.no_selling_plan")
  hidden_selling_plan_inputs.forEach(input => {
    input.value = selling_plan
  });
  if (!widget.querySelector(".selling_plan-select option:checked")) {
    if( widget.querySelector(".selling_plan-select")!=undefined)
    { widget.querySelector(".selling_plan-select").options[0].selected = "true"}
  }
  if (open_tab) {
    if (selling_plan_tab.classList.contains("active") && selling_plan == null) {
      selling_plan_tab
        .classList
        .remove('active')
      no_selling_plan_tab
        .classList
        .add('active')
      selling_plan_input
        .classList
        .remove("active")
      no_selling_plan_input
        .classList
        .add("active")
    }
    else if (no_selling_plan_tab.classList.contains('active') && selling_plan != null) {
      no_selling_plan_tab
        .classList
        .remove('active')
      selling_plan_tab
        .classList
        .add('active')
      no_selling_plan_input
        .classList
        .remove("active")
      selling_plan_input
        .classList
        .add("active")
    }
  }
}

document.addEventListener("DOMContentLoaded",()=>{
  setAutomaticSelectorOnLoad()
  setAutomaticSelector()
  setDefault()
  setVariants()
 document.querySelectorAll(".quantity-input__element").forEach(input => {
  input.addEventListener("change", function () {
    
    let newQuantity = input.value;
    let quantityLabel = document.querySelectorAll(".quantity-input__element");

    // quantityLabel.forEach(input => {
    //   input.value = newQuantity
    // })
  updateAllQuantityInputs(newQuantity)
    quantityInputs = document.querySelectorAll('input[type="hidden"][name="quantity"]');
    quantityInputs.forEach(input => {
      input.value=newQuantity;
    }

    )

    let new_discout_price = (Number(widget.dataset.discountPrice.replace(",", ".")) * newQuantity).toFixed(2)
    let new_price = (Number(widget.dataset.originalPrice.replace(",", ".")) * newQuantity).toFixed(2)
   
    if(currency_pos_after){
      widget.querySelector(".discount-price").innerHTML =  new_discout_price + currency;
      widget.querySelectorAll(".original-price").forEach(price => { price.innerHTML = new_price + currency})
    }
    else {
      widget.querySelector(".discount-price").innerHTML = currency + new_discout_price;
      widget.querySelectorAll(".original-price").forEach(price => { price.innerHTML = currency + new_price })
    }

  })
}) 
})



if (widget.querySelector(".selling_plan-select")) {
  let selling_plan_select = widget.querySelector(".selling_plan-select")

  selling_plan_select.addEventListener("change", function () {
    document.querySelectorAll("[name='selling_plan']").forEach(input => {
      input.value= selling_plan_select.value
    })
  })
}



document.querySelectorAll(".add-to-cart").forEach(element => {
 element.addEventListener("click", function (event) {
  
    let upselling_items = document.querySelectorAll(".upselling-checkbox:checked")
    if (upselling_items.length > 0) {
      event.preventDefault()
      let items = []
  
      let selling_plan = document.querySelector("input[name=selling_plan]")?.value;
      if(selling_plan == "" || selling_plan == undefined){
        selling_plan = null
      }
      console.log("selling_plan",selling_plan)
      let pdp_item = {
        id: document.querySelector("input[name=id]")?.value,
        selling_plan: selling_plan,
        quantity: document.querySelector(".quantity-input__element")?.value
      }
      items.push(pdp_item)
      upselling_items.forEach(item => {
        let add_item = {
          id: item.id,
          quantity: 1
        }
        items.push(add_item)
      })
      console.log("window", window.Shopify.onItemAdded())
      // window.Shopify.onItemAdded(items[1])
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", "Accept": "application/json"
        },
        body:
          JSON.stringify({
            items: items
          })
      }).then(response => {
        console.log("response",response)
        // renderCart()
        window.location.reload()
        
      })
    }
  
  
  })
});
document.querySelector(".upselling-product-wrapper")?.addEventListener("click", (event)=>{
  event.target.closest(".upselling-product-wrapper")?.querySelector(".radio-button-furlife-inner").classList.toggle("active")
 let checkboxInput = event.target.closest(".upselling-product-wrapper")?.querySelector(".upselling-checkbox")
 checkboxInput.checked = !checkboxInput.checked;

})


async function renderCart() {
  try {
    const response = await fetch(window.Shopify.routes.root + "?section_id=cart-drawer", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
    });

    if (!response.ok) {
      throw new Error("Error retrieving cart content.");
    }

    const htmlCart = await response.text();
    const newContent = new DOMParser().parseFromString(htmlCart, 'text/html')
    console.log("newContent", newContent);
    const lookfor = newContent?.querySelector('#MinimogCartDrawer').innerHTML;

    console.log("newContent2", lookfor);
    document.querySelector('#MinimogCartDrawer').innerHTML = lookfor;
  } catch (error) {
    console.log("Error:", error);
  }
}